
import ExampleProductItem from "./ExampleProductItem"

export default function ExampleProductsPage({data, theme}) {
  
  const deployExampleProducts = ()=>{
    return data.products.map((item, inx)=>{
      return <ExampleProductItem key={`exampleProductItem_inx_${inx}`} item={item} theme={theme}/>
    })
  }
  return (
    <div className='exampleProductsPage' style={{backgroundColor:`${theme.secondary_color}`}}>
      <h3 className="exampleProductsPage_header" style={{textShadow:`2px 2px 4px ${theme.primary_color}`, color:`${theme.accent_color}`}}>המוצרים שלנו</h3>
      <div className="exampleProductsPage_list">
        {deployExampleProducts()}
      </div>
    </div>
  )
}
